// extracted by mini-css-extract-plugin
module.exports = {"previewItem":"draggingAsset_previewItem__1kYAL","mediaItem":"draggingAsset_mediaItem__24bQe"};